import Vue from 'vue'
// @ts-ignore
import NoSsr from 'vue-no-ssr'
import bookmarkable from '../BookmarkButton/bookmarkable'

export default Vue.extend<any, any, any, any>({
  mixins: [bookmarkable],
  components: { NoSsr },
})
